import { LibraryBig, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthDialog } from "@/components/AuthDialog";
import { SettingsPopover } from "@/components/SettingsPopover";
import { useAuth } from "@/context/AuthContext";

export const Header = (props) => {
  const { user, logout, canAuth } = useAuth();
  return (
  <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-xl">
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-6 py-4">
      <a href="#" data-testid="logo-link" className="group flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md border border-border bg-card transition-transform duration-300 group-hover:-rotate-6">
          <LibraryBig className="h-5 w-5 text-primary" />
        </span>
        <span className="font-display text-sm font-bold uppercase tracking-[0.25em]">
          Avali Archive
        </span>
      </a>
      <nav className="hidden items-center gap-8 text-xs uppercase tracking-[0.2em] text-muted-foreground md:flex">
        <a
          href="#shelf"
          data-testid="nav-shelf-link"
          className="transition-colors duration-200 hover:text-foreground"
        >
          Shelf
        </a>
        <a
          href="#about"
          data-testid="nav-about-link"
          className="transition-colors duration-200 hover:text-foreground"
        >
          About
        </a>
      </nav>
      <div className="flex items-center gap-3">
        {user ? (
          <>
            <span
              data-testid="user-chip"
              className="hidden max-w-[140px] truncate text-xs text-muted-foreground sm:block"
            >
              {user.name || user.email}
            </span>
            <Button
              variant="ghost"
              size="sm"
              data-testid="logout-btn"
              onClick={logout}
              className="rounded-full transition-colors hover:bg-accent/10"
            >
              <LogOut className="mr-1 h-4 w-4" />
              Sign out
            </Button>
          </>
        ) : canAuth ? (
          <AuthDialog />
        ) : null}
        <SettingsPopover {...props} />
      </div>
    </div>
  </header>
  );
};
